import React, { useEffect, useState } from "react";
import "./loyaltyProgramCards.scss";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHourglass, faStar, faTrophy } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";
import { ITier } from "redux/reducers/models/loyalty";

interface IProps {
    type: "tier" | "points" | "expiry";
    points: number;
    expiringPoints?: number;
    tiers?: Array<ITier>;
    currentTierId?: number;
} 

export default function LoyaltyProgramCard(props: IProps) {
    const {type, points, expiringPoints = 0, tiers, currentTierId} = props;
    const {t} = useTranslation();
    const [currentTier, setCurrentTier] = useState<ITier>(null);
    const [nextTier, setNextTier] = useState<ITier>(null);

    useEffect(() => {
        if (tiers) {
            if (currentTierId) {
                //Set the user's current tier
                const foundTier = tiers?.find(tier => tier?.id == currentTierId);
                if (foundTier) {
                    setCurrentTier(foundTier);
                }
            }
            
            //Get the next tier if one exists
            const sortedTiers = tiers?.sort((a,b) => a.points_required - b.points_required)?.filter(tier => tier?.points_required > points);
            if (sortedTiers?.length > 0) {
                setNextTier(sortedTiers[0]);
            }
        }
    } ,[]);

    function getIcon(){
        switch (type) {
            case "tier":
                return faTrophy;
            case "points":
                return faStar;
            case "expiry":
                return faHourglass;
            default:
                return faStar;
        }
    }

    return (
        <div className="loyalty-program-card">
            <div>
                <div className={classNames("loyalty-program-card-icon", {[`loyalty-program-card-icon-${type}`]: type})}>
                    <FontAwesomeIcon icon={getIcon()} />
                </div>
            </div>

            {type === "tier" ? (
                <div className="loyalty-program-card-info-container">
                    <p className="loyalty-program-card-primary">{t("Tier progress")}</p>
                    {nextTier ? (
                        <p className="loyalty-program-card-secondary">{nextTier?.points_required - points} {t("more points to reach")} {nextTier?.title}</p>
                    ) : null}

                    <div style={{display: "flex", alignItems: "center", gap: "1rem"}}>
                        <div className="loyalty-program-card-meter-outer">
                            <div className="loyalty-program-card-meter-inner" style={{width: nextTier ? `${Math.abs(((points - (currentTier?.points_required ?? 0))/(nextTier?.points_required - (currentTier?.points_required ?? 0)))) * 100}%` : "100%"}}></div>
                        </div>
                        <p className="loyalty-program-card-meter-percent">{nextTier ? `${(Math.abs(((points - (currentTier?.points_required ?? 0))/(nextTier?.points_required - (currentTier?.points_required ?? 0)))) * 100)?.toFixed(2)}%` : "100%"}</p>
                    </div>
                    
                    <p className="loyalty-program-card-secondary">{currentTier?.title ?? t("No tier reached")} {nextTier ? `• ${points} / ${nextTier?.points_required} ${t("to")} ${nextTier?.title}` : null}</p>
                </div>
            )
            : type === "points" ? (
                <div className="loyalty-program-card-info-container">
                    <p className="loyalty-program-card-primary">{t("Available points")}</p>
                    <p className="loyalty-program-card-secondary">{t("Points you can spend today")}</p>
                    <p className="loyalty-program-card-points">{points} {t("pts")}</p>
                </div>
            ) : type === "expiry" ? (
                <div className="loyalty-program-card-info-container">
                <p className="loyalty-program-card-primary">{t("Expiring points")}</p>
                <p className="loyalty-program-card-secondary">{t("Use points before they expire")}</p>
                <p className="loyalty-program-card-points">{expiringPoints} {t("pts")}</p>
            </div>
            ) : null}
        </div>
    );
}